import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Careers from "@/pages/Careers";
import { ViewModeProvider } from "@/contexts/ViewModeContext";
import { ThemeProvider } from "@/contexts/ThemeContext";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <ViewModeProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </BrowserRouter>
        </ViewModeProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
